__turbopack_context__.v({
  "indicator": "OnsiteIndicatore-module-scss-module__TxgnDq__indicator",
  "remix": "OnsiteIndicatore-module-scss-module__TxgnDq__remix",
});
